import React from 'react';
import IdleTimer from 'react-idle-timer';
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../slice/UserSlice";
import { saveReturnUrl } from "../../../helper/return-url-helper";

// Idle timeout: 24 hours in milliseconds
const IDLE_TIMEOUT_MS = 24 * 60 * 60 * 1000; // 24 hours = 86,400,000 ms

function UserIdleTimer() {
    const dispatch = useDispatch();

    function handleIdle() {
        saveReturnUrl(window.location.pathname + window.location.search);
        dispatch(logoutUser());
    }

    return (
        <IdleTimer
            timeout={IDLE_TIMEOUT_MS}
            onIdle={handleIdle}
            crossTab={true}
            startOnMount={true}
            debounce={250}
        />
    );
}

export default UserIdleTimer;
